import { render, staticRenderFns } from "./OrthoShoulderNeck.vue?vue&type=template&id=082bc562&scoped=true"
import script from "./OrthoShoulderNeck.vue?vue&type=script&lang=js"
export * from "./OrthoShoulderNeck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082bc562",
  null
  
)

export default component.exports